import styled from 'styled-components'
import { theme } from '../../../style/theme'
import { colorTheme } from '../../../style/theme/colorTheme'

export const NavBarSwitch = styled.div`
	padding: 0 1.75em;
	margin-top: 2.13em;
	margin-bottom: 1.25em;

	&.toggled {
		padding: 0 0.94em;

		.switch-label {
			display: none;
		}
	}

	.switch-label {
		color: ${colorTheme.navBar.switch.title};
	}

	@media screen and (max-width: ${theme.point820}) {
		margin: 1.42em 0 2.14em;
		padding: 0 1.43em;

		input + span .switch-label {
			font-size: 1.43em;
			font-weight: 700;
			max-width: 10.7em;
		}
	}

	@media screen and (max-width: ${theme.point720}) {
		margin: 1.25em 0 1.88em;
		padding: 0 1.25em;

		input + span .switch-label {
			font-size: 1.25em;
			max-width: 8em;
		}
	}
`
NavBarSwitch.displayName = 'NavBarSwitch'
